import React from 'react';

import Icon from '../../../molecules/Icon';

import { toggleFilter } from '../utils/functions';

import { color } from '../../../atoms/colors';

import { Button } from '../styles/CategoryButton.styled';

const CategoryButton = ({ filter, category, isActive, setActiveFilters }) => (
  <Button
    type="button"
    key={category}
    onClick={() => toggleFilter(setActiveFilters, filter?.title, category)}
  >
    <div className={`check-box ${isActive ? 'active' : ''}`}>
      <Icon id="check" width="12px" height="12px" fillColor={color.blue[500]} />
    </div>
    {category}
  </Button>
);

export default CategoryButton;
